import { all, call } from "redux-saga/effects"

import { creationFlow } from "./creation/actions"
import { currentFetchingFlow } from "./current/actions"

export function* paymentsSaga() {
  yield all([call(creationFlow), call(currentFetchingFlow)])
}
